import { Tag, TagCloseButton, TagLabel } from "@chakra-ui/react";
import React, { memo, useCallback, useMemo } from "react";
import colors from "app/colors";

interface IProps {
  id: string;
  label: string;
  isActive: boolean;
  leftChar?: string;
  isModified?: boolean;
  onClose?: (id: string) => void;
}

const Pill: React.FC<IProps> = ({
  id,
  label,
  isActive,
  leftChar,
  isModified,
  onClose,
}) => {
  const isRemovable = useMemo(() => onClose !== undefined, [onClose]);

  const color = useMemo(() => {
    if (isActive) {
      return colors.blue;
    }
    return colors.gray50;
  }, [isActive]);

  const borderColor = useMemo(() => {
    if (isActive && isRemovable) {
      return colors.blue;
    }
    return colors.grayPrimary;
  }, [isActive, isRemovable]);

  const closeButtonColor = useMemo(() => {
    if (isActive) {
      return colors.blue;
    }
    return colors.gray50;
  }, [isActive]);

  const fontWeight = useMemo(() => {
    if (isActive) {
      return 700;
    }
    return 500;
  }, [isActive]);

  const onCloseClicked = useCallback(() => {
    if (!onClose) return;
    onClose(id);
  }, [id, onClose]);

  return (
    <Tag
      paddingX={2}
      borderRadius={16}
      borderWidth={1}
      borderColor={borderColor}
      size="sm"
      color={color}
      backgroundColor={colors.transparent}
    >
      <TagLabel
        fontWeight={fontWeight}
        fontSize={13}
        fontStyle={!isActive ? "italic" : undefined}
        color={color}
        isTruncated
      >
        {leftChar}
        {label}
        {isModified && "*"}
      </TagLabel>
      {isRemovable && (
        <TagCloseButton onClick={onCloseClicked} color={closeButtonColor} />
      )}
    </Tag>
  );
};

export default memo(Pill);
